(function () {
  function initTrust(section) {
    var track = section.querySelector('.cac-trust-track');
    if (!track) return;

    var touching = false;
    track.addEventListener('touchstart', function () {
      touching = true;
      track.style.animationPlayState = 'paused';
    }, { passive: true });
    track.addEventListener('touchend', function () {
      touching = false;
      setTimeout(function () {
        if (!touching) track.style.animationPlayState = 'running';
      }, 600);
    });
  }

  function initAll() {
    document.querySelectorAll('.cac-trust-outer').forEach(initTrust);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.cac-trust-outer') || e.target;
    if (section) initTrust(section);
  });
})();